import { Link, useNavigate } from "react-router-dom";
import "../css/Footer.css";
import colors from '../colors';

function Footer()
{
    return(

        <div className="footer-and-copyright">
        <div className="footer">

        <div className="footer-overlay" style={{padding:"20px"}}>

        <img id="footer-logo" src={require("../images/logo-white.png")} alt={process.env.REACT_APP_ALT}></img>
        <h3 id="brand-name">حرف به حرف</h3>
        <p style={{marginTop:"-20px", color:"#ffffffc4"}}>سئو خودکار، از حرف تا هدف </p>

        <div  id="footer-links">

        <span className="footer-column">
            <h4>لینک های مفید</h4>
        <Link to="/weblog"><p className="footer-link" >وبلاگ</p></Link>
        <Link to="/posts"><p className="footer-link">آشنایی با سئو</p></Link>
        <Link to="/dashboard"><p className="footer-link">داشبورد کاربران</p></Link>
        </span>

        <span className="footer-column">
            <h4>پلن های اشتراکی</h4>
        <Link to="/register"><p className="footer-link" >پلن رایگان</p></Link>
        <Link to="/"><p className="footer-link">پلن هواپیما</p></Link>
        <Link to="/"><p className="footer-link">پلن موشک</p></Link>
        </span>

        <span className="footer-column">
            <h4>راه های ارتباطی</h4>

            
            <span>
                <i className="pi pi-envelope" style={{marginLeft:"10px"}}></i>
                info@harfbeharf.com
            </span>
            
            <p></p>
            
            <span style={{direction:"rtl"}}>
                <i className="pi pi-phone" style={{marginLeft:"10px"}}></i>
                98935-23-33-881+
            </span>

            <p></p>

            <span style={{direction:"rtl"}}>
                <i className="pi pi-map-marker" style={{marginLeft:"10px"}}></i>
                تهران، خیابان نوبنیاد، خیابان گلزار جنوبی، کوچه لادن شرقی، 12 متری ولیعصر، بن بست قائم، پلاک 7
            </span>
        
        
        </span>

        </div>


        </div>
            </div>
        <div className="copyright">
            <span>کپی رایت 1404 - تمامی حقوق برای سایت {process.env.REACT_APP_PROJECT_NAME} محفوظ است. طراحی سایت از 
            </span>
            &nbsp;
            <a href="https://mustang.ir" target="_blank" style={{color:colors.primary}}>موستانگ</a>
        </div>
        </div>

        
    );

}

export default Footer;